import { EntityDescriptor } from '../business-logic';
import { subscriptionsSchema } from '../schemas/subscriptions';

export const subscriptionEntity: EntityDescriptor = {
	subscriptions: {
		schema: subscriptionsSchema,
		migrationStrategies: {
			1: function (oldDoc: any) {
				/**
				 * New field added:
				 *  * nextCancellationEffectiveDate
				 * */
				oldDoc.nextCancellationEffectiveDate =
					oldDoc.nextCancellationEffectiveDate ?? '';

				return oldDoc;
			},
			2: function (oldDoc: any) {
				/**
				 * New field added:
				 *  * cancellationNoticeDeadline
				 * */

				return oldDoc;
			},
			3: function (oldDoc) {
				/**
				 * New field added:
				 *  * disallowCancelCancellation
				 * */

				return oldDoc;
			},
		},
	},
};
